/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

/**
 * region for components*/
import CounterCardBySite from './CounterCardByBySite';
import LoadingProgress from '../../components/common/LoadingProgress'

/**
 * region for styles*/
import { counterProductKeywordStyle } from './style/counterProductKeywordStyle';

/**
 * region for hepers*/
import ajax from '../../helpers/ajax';

/**
 * region for constans*/
import Constants from '../../constants/Constants';

class CounterProductKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            counters: [],
            mode: Constants.MODE_LOADING
        }
    }

    load() {
        let self = this;
        const { keyword } = this.props
        const { IDKEYWORD } = keyword

        ajax.get(Constants.ROUTE_API_CONTENT_GET_COUNTERS_BY_SITE_KEYWORD,
            {
                requestData: { idkeyword: IDKEYWORD },
                success: function (response) {
                    const { data } = response
                    const newData = data.map(item => {
                        const { Id } = item
                        let order = 0;

                        switch (Id) {
                            case 'XP':
                                order = 0;
                                break;
                            case 'EE':
                                order = 1;
                                break;
                            case 'AE':
                                order = 2;
                                break;
                            case 'EN':
                                order = 3;
                                break;
                            default:
                                order = 0;
                                break;
                        }

                        return { ...item, order }
                    })
                    self.setState({ counters: newData, mode: Constants.MODE_LOADED });
                }
            });
    }

    componentDidMount() {
        this.load();
    }
    render() {
        const { classes } = this.props;
        const { mode, counters } = this.state
        return (
            <div className={classes.contentCount}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={2}>                           
                            {
                                mode === Constants.MODE_LOADING ?
                                    (<LoadingProgress />) :
                                    (<CounterCardBySite counters={counters}/>)
                            }                           
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}
CounterProductKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(counterProductKeywordStyle)(CounterProductKeyword);





